function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E9EBF0",
    style: {
      fill: "#E9EBF0",
      fill: "color(display-p3 0.9137 0.9216 0.9412)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2996 23.3001C23.2996 24.6001 21.6996 25.5001 19.9996 25.5001C16.9996 25.5001 14.5996 23.1001 14.5996 20.1001C14.5996 17.1001 16.9996 14.6001 19.9996 14.6001C21.1996 14.6001 22.3996 15.0001 23.2996 15.7001",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4002 19.4C26.0629 19.4 26.6002 18.8627 26.6002 18.2C26.6002 17.5373 26.0629 17 25.4002 17C24.7375 17 24.2002 17.5373 24.2002 18.2C24.2002 18.8627 24.7375 19.4 25.4002 19.4Z",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z",
    stroke: "#0B1C56",
    style: {
      stroke: "#0B1C56",
      stroke: "color(display-p3 0.0431 0.1098 0.3373)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundIcon);
export default __webpack_public_path__ + "static/media/roundIcon.2ada77ad34c15c0cff14c5aaaa583ac3.svg";
export { ForwardRef as ReactComponent };